import React, { useCallback, useState, useEffect, Fragment } from "react";
import {
  Table,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Input,
  Row,
  Col,
  Label,
  FormGroup,
  Button,
} from "reactstrap";
import { LoadingMessage } from "../../Controls";
import { WizzMode, DenominationStatus } from "../../types";
import { useEntities } from "../../Wizzard";
import style from "./../../styles.module.scss";
import { FormattedNumber } from "../../../FormattedNumber/FormattedNumber";
import { DateField, truncateNumber } from "../../../../utils";
import LaddaButton, { EXPAND_RIGHT } from "react-ladda";
import { showToast, debounce } from "../../../../utils/Helper";
import CircularProgress from "../../../CircularProgress/CircularProgress";
import { FormField } from "../../../../utils";
import { Combobox } from "../../../Modal/Order/Field/Field";
import { HistoryDefault } from "../../../..";
import Translate from "../../../../utils/Translator";

export const Denominations = ({ mode, services, assetId, toggleOrder, assetInfo }) => {
  const [readonly, setReadonly] = useState(mode == WizzMode.View); // va a ser mediante un useEffect al traer los denominations
  const [loading, setLoading] = useState(true);
  const [editing, setEditing] = useState(false);
  const [denominations, setDenominations] = useState([]);
  const [empty, setEmpty] = useState(true);
  const [decimalAmount, setDecimalAmount] = useState();
  const [canSave, setCanSave] = useState(false);
  const [modalHistory, setModalHistory] = useState(false);
  const [filters, setFilters] = useState({ text: "", status: "Active" });
  // const debounceCallback = useCallback(
  //   debounce((nextValues) => rootOnChange(nextValues), 500),
  //   []
  // );

  // const rootOnChange = () => {
  //   loadDenominations();
  // };

  const onChange = (fields) => {
    const nextValues = {
      ...filters,
      status: fields.status,
    };
    setFilters(nextValues);
  };

  useEffect(() => {
    loadDenominations();
  }, [filters.status]);

  const loadDenominations = () => {
    setLoading(() => true);
    services.fetchPortfolios({ id: assetId, date: new Date() }).then((res) => {
      let slotsDict = [];
      res.portfolio.forEach((p) => {
        p.PortfolioQuantity = truncateNumber(+p.PortfolioQuantity, assetInfo.SubAssetClassDecimalPlaces);

        slotsDict.push({
          account: +p.accountId,
          availableSlots: Math.ceil(+p.PortfolioQuantity / +assetInfo.AssetSheetSize),
          AccountNumber: p.AccountNumber,
          AccountName: p.AccountName,
          BalanceType: p.PortfolioBalanceType,
          BookType: p.booktype,
          slots: [],
          availableSlotsAux: Math.ceil(+p.PortfolioQuantity / +assetInfo.AssetSheetSize),
          availableSlotsActive: 0,
          availableSlotsInactive: 0,
        });
      });

      services
        .fetchDenominations({ AssetId: assetId, filter: filters.status })
        .then((res) => {
          const newDenominations = [];
          // Adds slots for each account combining already defined denominations
          let currentAccountBefore = slotsDict;
          for (let i = 0; i < slotsDict.length; i++) {
            //if (filters.status == "Inactive" || filters.status == "" || filters.status == "Active") {
            currentAccountBefore[i] = {
              ...currentAccountBefore[i],
              availableSlots: 0,
            };

            //if (filters.status == "Inactive" || filters.status == "" || filters.status == "Active") {
            for (let denIdx = 0; denIdx < res.denominations.length; denIdx++) {
              const d = res.denominations[denIdx];
              if (
                +d.Accountid === +currentAccountBefore[i].account &&
                d.balancetype === currentAccountBefore[i].BalanceType &&
                d.booktype === currentAccountBefore[i].BookType
              ) {
                //if (d.DenominationStatus == "Inactive") {
                currentAccountBefore[i] = {
                  ...currentAccountBefore[i],
                  availableSlots: currentAccountBefore[i].availableSlots + 1,
                };
                if (
                  (+d.Accountid === +currentAccountBefore[i].account &&
                    d.DenominationStatus == "Active" &&
                    d.balancetype === currentAccountBefore[i].BalanceType &&
                    d.booktype === currentAccountBefore[i].BookType &&
                    filters.status == "") ||
                  filters.status == "Active"
                ) {
                  currentAccountBefore[i] = {
                    ...currentAccountBefore[i],
                    availableSlotsActive: currentAccountBefore[i].availableSlotsActive + 1,
                  };
                }
                if (
                  +d.Accountid === +currentAccountBefore[i].account &&
                  d.balancetype === currentAccountBefore[i].BalanceType &&
                  d.DenominationStatus == "Inactive" &&
                  d.booktype === currentAccountBefore[i].BookType &&
                  filters.status == ""
                ) {
                  currentAccountBefore[i] = {
                    ...currentAccountBefore[i],
                    availableSlotsInactive: currentAccountBefore[i].availableSlotsInactive + 1,
                  };
                }
              }
            }
          }

          for (let i = 0; i < slotsDict.length; i++) {
            let situation = "";
            if (filters.status == "Active") {
              if (currentAccountBefore[i].availableSlotsActive > currentAccountBefore[i].availableSlotsAux) {
                //tienen de sobra deben eliminar
                //pasa cuando le dan inactive  sin tener menos cantidad de la necesaria
                // currentAccountBefore[i] = {
                //   ...currentAccountBefore[i],
                //   availableSlots: currentAccountBefore[i].availableSlotsAux,
                // };
                situation = "delete";
              } else if (
                currentAccountBefore[i].availableSlotsActive < currentAccountBefore[i].availableSlotsAux
              ) {
                //tienen de mas deben anadir
                currentAccountBefore[i] = {
                  ...currentAccountBefore[i],
                  availableSlots: currentAccountBefore[i].availableSlotsAux,
                };
                //situation = "less";
              } else {
                //todo ok
              }
            } else if (filters.status == "") {
              if (currentAccountBefore[i].availableSlotsActive < currentAccountBefore[i].availableSlotsAux) {
                //tienen de mas deben anadir
                currentAccountBefore[i] = {
                  ...currentAccountBefore[i],
                  availableSlots:
                    currentAccountBefore[i].availableSlotsAux +
                    currentAccountBefore[i].availableSlotsInactive,
                };
                //situation = "less";
              } else if (
                currentAccountBefore[i].availableSlotsActive > currentAccountBefore[i].availableSlotsAux
              ) {
                situation = "delete";
              }
            }
            let currentAccount = currentAccountBefore[i];

            for (let j = 1; j <= currentAccount.availableSlots; j++) {
              let newDenomination = {
                Accountid: +currentAccount.account,
                Assetid: assetId,
                AccountNumber: currentAccount.AccountNumber,
                AccountName: currentAccount.AccountName,
                DenominationId: "",
                IsEditable: true,
                balancetype: currentAccount.BalanceType,
                booktype: "Self",
                disabled: false,
                situation: situation,
              };
              for (let denIdx = 0; denIdx < res.denominations.length; denIdx++) {
                const d = res.denominations[denIdx];
                if (
                  +d.Accountid === +currentAccount.account &&
                  d.balancetype === currentAccountBefore[i].BalanceType &&
                  d.booktype === currentAccountBefore[i].BookType
                ) {
                  let found = false;
                  for (let slotsIdx = 0; slotsIdx < currentAccount.slots.length; slotsIdx++) {
                    if (currentAccount.slots[slotsIdx].DenominationId === d.DenominationId) {
                      found = true;
                      break;
                    }
                  }
                  if (!found) {
                    newDenomination = {
                      ...newDenomination,
                      ...d,
                    };
                    break;
                  }
                }
              }
              // agregar newDenomination a algo!!
              if (currentAccount.availableSlots > 0) {
                if (newDenomination.DenominationId !== "") {
                  newDenomination = {
                    ...newDenomination,
                    disabled: true,
                  };
                } else {
                  newDenomination = {
                    ...newDenomination,
                    situation: "add",
                  };
                }
                if (filters.status == "" && newDenomination.DenominationStatus == "Inactive") {
                  newDenomination = {
                    ...newDenomination,
                    situation: "",
                  };
                }
                currentAccount.slots.push(newDenomination);
              }
            } //sale del for grande

            currentAccount.slots.forEach((slot) => {
              newDenominations.push(slot);
            });
          }

          setDenominations(newDenominations);
        })
        .finally(() => {
          setLoading(() => false);
        });
    });
  };
  useEffect(() => {
    if (mode && assetId && assetInfo.AssetSheetSize) {
      setReadonly(mode == WizzMode.View);
      loadDenominations();
    }
  }, [mode, assetInfo, assetId]);

  useEffect(() => {
    if (services.saveDenominations) setCanSave(true);
  }, [services]);

  const handleSave = (idx, denomination) => {
    const denominationsToSave = [denomination];
    services
      .saveDenominations({ AssetId: assetId, denominations: denominationsToSave })
      .then((res) => {
        if (res.result.Code === 400) showToast(res.result.Description, true);
        else showToast("Denominations saved succesfully");
        loadDenominations();
      })
      .catch((err) => {
        console.error(err);
        showToast("Error saving denominations", true);
      });
  };

  const handleAddDenomination = (denomination, fn) => {
    services
      .addDenominations({
        DenominationId: denomination.DenominationId,
        BasicAccountId: denomination.Accountid,
        AssetId: assetId,
        BalanceType: denomination.balancetype,
      })
      .then((res) => {
        if (res.result.Code === 400) showToast(res.result.Description, true);
        else {
          showToast("Denominations added succesfully");
          fn(res.denomination);
        }
      })
      .catch((err) => {
        showToast("Error adding denominiations", true);
      });
  };

  const handleHistory = (denomination) => {
    setModalHistory({ process: "Denomination", processCharId: denomination, processId: assetId });
  };
  return (
    <div>
      <div className={style.btnDenominations}>
        <DropDownFilterStatus value={filters.status} onChange={onChange} />
      </div>
      <div>
        <Table>
          <thead>
            <tr>
              <th className={style.column20}>{Translate("Account")}</th>
              <th className="w-30">Origin Denomination</th>
              <th className="w-30">Denomination Ticker</th>
              <th className={`${style.column10} ${style.alignCenter}`}>Status</th>
              <th className={`${style.column10} ${style.alignCenter}`}>Balance Type</th>
              <th className={`${style.column10} ${style.alignCenter}`}>Book Type</th>
              <th className={style.column10} />
            </tr>
          </thead>
          <tbody>
            {!loading ? (
              <Fragment>
                {denominations.map((item, idx) => (
                  <DenominationRow
                    denomination={item}
                    editingGlobal={editing}
                    setEditingGlobal={setEditing}
                    handleSave={(d) => handleSave(idx, d)}
                    canSave={canSave}
                    handleHistory={(d) => handleHistory(d)}
                    handleAddDenomination={(d, f) => handleAddDenomination(d, f)}
                  />
                ))}
                {denominations.length == 0 && <EmptyOrLoading />}
              </Fragment>
            ) : (
              <EmptyOrLoading loading={loading} />
            )}
          </tbody>
        </Table>
      </div>
      {modalHistory && (
        <HistoryDefault
          open={true}
          {...modalHistory}
          onHistoryRequest={services.fetchHistoryByCharId}
          onToggle={() => setModalHistory(false)}
        />
      )}
    </div>
  );
};

const DenominationRow = ({
  denomination,
  editingGlobal,
  setEditingGlobal,
  handleSave,
  canSave,
  handleHistory,
  handleAddDenomination,
}) => {
  const [editing, setEditing] = useState(false);
  const [loading, setLoading] = useState(false);
  const [denominationValue, setDenominationValue] = useState(denomination.DenominationId);
  const [denominationTicker, setDenominationTicker] = useState(denomination.DenominationTicker);
  const [selectedDenominationStatus, setSelectedDenominationStatus] = useState(
    denomination.DenominationStatus
  );
  const [disabled, setDisabled] = useState(denomination.disabled);
  const [denominationSituation, setDenominationSituation] = useState(denomination.situation);
  const toggleEditing = () => {
    setEditing((prev) => !prev);
    setEditingGlobal((prev) => !prev);
  };

  const handleCancel = () => {
    toggleEditing();
    handleOnChange("", denomination.DenominationId);
    setLoading(() => false);
  };

  const fn = (res) => {
    //setDenominations(res);
    denomination = {
      ...denomination,
      DenominationId: res.DenominationId,
      disabled: false,
    };
    setDisabled(true);
    setDenominationSituation("");
    setDenominationTicker(res.DenominationTicker);
    setDenominationValue(res.DenominationId);
    setSelectedDenominationStatus(res.DenominationStatus);
  };
  const handleNewDenomination = (name, value) => {
    denomination = {
      ...denomination,
      DenominationId: denominationValue,
    };
    handleAddDenomination(
      {
        ...denomination,
      },
      fn
    );
  };

  const handleOnChange = (name, value) => {
    setDenominationValue(() => value);
  };

  const handleOnChangeTicker = (name, value) => {
    setDenominationTicker(() => value);
  };

  const handleHistoryDem = (denominationValue) => {
    //llamar funcion a implementar que trae history
    //fetchHistoryByCharId;
    handleHistory(denominationValue);
  };

  const handleOnSave = () => {
    setLoading(() => true);
    handleSave({
      ...denomination,
      DenominationId: denominationValue,
      DenominationTicker: denominationTicker,
      DenominationStatus: selectedDenominationStatus,
    });
    toggleEditing();
  };

  return (
    <tr
      className={
        denominationSituation == "add"
          ? style.rowDenominationAdd
          : denominationSituation == "delete"
          ? style.rowDenominationDelete
          : style.rowDenomination
      }
    >
      <td>
        {denomination.AccountNumber} {denomination.AccountName}
      </td>
      <td>
        <FormField
          name="DenominationId"
          label="Denomination"
          value={denominationValue}
          disabled={disabled}
          onChange={handleOnChange}
        />
      </td>
      <td>
        <FormField
          name="DenominationTicker"
          label="Denomination Ticker"
          value={denominationTicker}
          disabled={!editing}
          onChange={handleOnChangeTicker}
        />
      </td>
      <td>
        <Combobox
          value={selectedDenominationStatus}
          items={[
            { id: "Inactive", description: "Inactive" },
            { id: "Active", description: "Active" },
          ]}
          disabled={!editing}
          emptyLabel={""}
          onChange={(v) => setSelectedDenominationStatus(v)}
        />
      </td>
      <td className={style.alignCenter}>{denomination.balancetype}</td>
      <td className={style.alignCenter}>{denomination.booktype}</td>

      {canSave ? (
        <td>
          {editing ? (
            <Fragment>
              <Button disabled={loading} onClick={handleCancel} className="m-1">
                Cancel
              </Button>
              <LaddaButton
                className="btn btn-ladda btn-primary m-1"
                loading={loading}
                onClick={handleOnSave}
                data-style={EXPAND_RIGHT}
              >
                Save
              </LaddaButton>
            </Fragment>
          ) : !disabled ? (
            <Button className="m-1" disabled={editingGlobal} onClick={handleNewDenomination}>
              Save
            </Button>
          ) : (
            <Button className="m-1" disabled={editingGlobal} onClick={toggleEditing}>
              Edit
            </Button>
          )}
        </td>
      ) : (
        <td />
      )}
      <td>
        <Button
          outline
          color="primary"
          size="sm"
          key={`history-${denomination.DenominationId}`}
          onClick={() => handleHistoryDem(denomination.DenominationId)}
          className={style.iconBtn}
        >
          <i className="fa fa-history"></i>
        </Button>
      </td>
    </tr>
  );
};

const EmptyOrLoading = ({ loading }) => (
  <tr>
    <td colSpan="12">
      {loading ? (
        <LoadingMessage text="Loading denominations" />
      ) : (
        <span className="text-center d-block h5 m-3" style={{ textAlign: "center" }}>
          No denominations
        </span>
      )}
    </td>
  </tr>
);

const DropDownFilterStatus = ({ value, onChange }) => (
  <div style={{ marginBottom: "16px" }}>
    <UncontrolledDropdown style={{ minWidth: "140px" }}>
      <DropdownToggle caret color="secondary" className={style.dropdown}>
        {value == "" ? "All Statusses" : value}
      </DropdownToggle>
      <DropdownMenu>
        <DropdownItem key={`status-all`} onClick={() => onChange({ status: "" })}>
          {"All Statusses"}
        </DropdownItem>
        {Object.values(DenominationStatus).map((status) => (
          <DropdownItem key={`status-${status}`} onClick={() => onChange({ status: status })}>
            {status}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </UncontrolledDropdown>
  </div>
);
